import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';

const reset = () => defaultState;

const defaultState = {};

const mergeBenchmarkSettings = (state, action) => {
  const benchmarkSettings = action?.payload?.entities?.companyBenchmarkSettings;
  Object.keys(benchmarkSettings).forEach((key) => {
    if (state[key]) {
      state[key].benchmarkAttributes = {
        ...state[key].benchmarkAttributes,
        ...benchmarkSettings[key].benchmarkAttributes,
      };
    } else {
      state[key] = benchmarkSettings[key];
    }
  });
};

const replaceAssociatedAttribute = (state, action) => {
  const newAttributeMapping = action?.payload;
  if (!newAttributeMapping.attributeId) {
    state[newAttributeMapping.companyId].benchmarkAttributes[
      newAttributeMapping.benchmarkAttributeId
    ].associatedAttribute = { id: null, names: {} };
    return;
  }
  state[newAttributeMapping.companyId].benchmarkAttributes[
    newAttributeMapping.benchmarkAttributeId
  ].associatedAttribute = {
    id: newAttributeMapping.attributeId,
    names: newAttributeMapping.names,
  };
};

const replaceDefaultValue = (state, action) => {
  const value = action?.payload;
  state[value.companyId].benchmarkAttributes[value.benchmarkAttributeId].defaultValue = {
    id: value.benchmarkAttributeValueId,
    name: value.name,
  };
  if (value.ungroupedValue) {
    state[value.companyId].benchmarkAttributes[value.benchmarkAttributeId].ungroupedValue = value.ungroupedValue;
  }
};

const companiesSettings = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(accountActions.logout.pending, reset)
    .addCase(accountActions.switchCompany.pending, reset)
    .addCase(benchmarkActions.fetchCompaniesBenchmarkSettings.fulfilled, mergeBenchmarkSettings)
    .addCase(benchmarkActions.associateBenchmarkAttribute.fulfilled, replaceAssociatedAttribute)
    .addCase(benchmarkActions.updateCompanyDefaultAttributeValue.fulfilled, replaceDefaultValue)
    .addCase(benchmarkActions.deleteBenchmarkAttributeAssociation.fulfilled, replaceAssociatedAttribute);
});

export { companiesSettings };
